import { render } from "./LinkIcon.vue?vue&type=template&id=1021ca4c&scoped=true"
const script = {}

import "./LinkIcon.vue?vue&type=style&index=0&id=1021ca4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1021ca4c"]])

export default __exports__